import '@/utils/boot-splash'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './themes/themes.css'
import App from './App.tsx'
import '@/services/api/axios'
import { registerChunkRecoveryHandlers } from '@/utils/chunk-recovery'
import { captureTwaWrapperFromUrl } from '@/utils/twa-wrapper'
import { registerShareTargetWorker } from '@/utils/register-share-target'

registerChunkRecoveryHandlers()
captureTwaWrapperFromUrl()
registerShareTargetWorker()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
